import { Component, OnDestroy, OnInit } from '@angular/core';
import { Bestnode } from '@3ddv/ngx-sites-builder-lib';
import { Subscription } from 'rxjs';
import { ToolsService } from '../services/tools.service';
import { Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sbeditor-tool-bestnode',
  templateUrl: './bestnode.component.html',
  styleUrls: ['./bestnode.component.scss']
})
export class BestnodeComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription>;
  public tool: Bestnode;
  @Output() exportTool = new EventEmitter<Bestnode>();

  constructor(private toolsService: ToolsService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      // console.log(res)
      if (res.bestnode) {
        this.tool = JSON.parse(JSON.stringify(res.bestnode));
      } else {
        console.error("bestnode tool not found");
        return;
      }

    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  onSelect($event): void {
    this.exportTool.emit(this.tool);
  }

  public getTool() {
    console.log(this.tool)
    return this.tool;
  }
}
